import { z } from 'zod'
import { containsNewLine, isrcInvalidCheck } from '@App/helpers/work-entities-fields-validators'
import {
    durationMessage,
    integerMessage,
    newlineMessage,
    numericMessage,
    requiredMessage,
    stringMessage,
    stringSizeMaxMessage,
} from '@Entities/schemas/work/error-messages'
import { DURATION_REGEX } from '@Const/regexp'

const recordingSchema = z.object({
    id: z
        .number({ error: numericMessage('ID') })
        .int(integerMessage('ID'))
        .optional()
        .nullable(),
    localId: z
        .number({ error: numericMessage('Local ID') })
        .int(integerMessage('Local ID'))
        .optional(),
    title: z
        .string({
            error: (issue) => (issue.received === 'undefined' ? requiredMessage('Title') : stringMessage('Title')),
        })
        .max(100, stringSizeMaxMessage('Title', 100))
        .refine((val) => !containsNewLine(val), newlineMessage('Title')),
    artistName: z
        .string({
            error: (issue) =>
                issue.received === 'undefined' ? requiredMessage('Artist name') : stringMessage('Artist name'),
        })
        .max(60, stringSizeMaxMessage('Artist name', 60))
        .refine((val) => !containsNewLine(val), newlineMessage('Artist name')),
    isrc: z
        .string({ error: stringMessage('ISRC') })
        .refine((isrc) => !isrcInvalidCheck(isrc), 'Invalid ISRC Format')
        .nullable(),
    duration: z
        .string({ error: stringMessage('Duration') })
        .regex(DURATION_REGEX, durationMessage())
        .nullable()
        .or(z.literal('')),
    releaseDate: z
        .string({
            error: (issue) =>
                issue.received === 'undefined' ? requiredMessage('Release date') : stringMessage('Release date'),
        })
        .nullable(),
    label: z
        .string({
            error: (issue) => (issue.received === 'undefined' ? requiredMessage('Label') : stringMessage('Label')),
        })
        .max(60, stringSizeMaxMessage('Label', 60))
        .refine((val) => !containsNewLine(val), newlineMessage('Label'))
        .nullable(),
    amend: z.boolean().optional().nullable(),
    publishOwner: z
        .string({ error: stringMessage('Publisher owner') })
        .optional()
        .nullable(),
    publishYear: z
        .number({ error: numericMessage('Publish year') })
        .optional()
        .nullable(),
    albumTitle: z
        .string({ error: stringMessage('Album title') })
        .optional()
        .nullable(),
})

export default recordingSchema
